<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			steps: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="flex flex-col gap-y-10 lg:gap-y-24">
	{#each content.steps as card, index}
		<Blok content={card} {index} isLastStep={index === content.steps.length - 1} />
	{/each}
</div>
